<template>
    <div>
        <div
            v-for="(recipient, i) in updatedSignature.Recipients"
            v-bind:key="i">
            <recipient-control
                v-bind:can-resend="canResend"
                v-bind:recipient="recipient"
                v-bind:class="i > 0 ? 'mt-3' : ''"
                v-on:update-recipient="updateRecipient(recipient.RecipientId, $event)"
                v-on:toggle-edit="toggleEditingRecipient(recipient.RecipientId, $event)" />
        </div>
        <div
            v-if="canResend && !inEditMode"
            class="mt-3">
            <div>
                <div class="fw-bold">
                    {{ resendNotice }}
                </div>
                <pc-loader v-bind:loading="resending">
                    <pc-button v-on:click="resendNotifications">
                        {{ resendButtonText }}
                    </pc-button>
                </pc-loader>
            </div>
        </div>
    </div>
</template>
<script>
    import recipientControl from "./eSignatureRecipientControl.vue";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/eSignatureActionRow.i18n";

    export default {
        components: {
            recipientControl
        },
        props: {
            eSignature: { type: Object, required: true },
            resending: { type: Boolean, required: false, default: false },
            isReadOnlyUser: { type: Boolean, required: false, default: false }
        },
        emits: ["signature-updated", "resend-notifications"],
        data() {
            return {
                // Clone the eSignature prop so we can keep track of modifications
                // without modifying our prop directly
                updatedSignature: JSON.parse(JSON.stringify(this.eSignature)),
                recipientsBeingEdited: {},
                inEditMode: false
            };
        },
        computed: {
            canResend() {
                return !this.isReadOnlyUser && this.eSignature.CanBeResent;
            },
            ...mapI18n(KEYS, NAMESPACE)
        },
        methods: {
            updateRecipient(recipientId, updates) {
                const recipient = this.updatedSignature.Recipients.find((r) => {
                    return r.RecipientId === recipientId;
                });
                recipient.FirstName = updates.first;
                recipient.LastName = updates.last;
                recipient.Email = updates.email;
                recipient.isUpdated = true;
                recipient.Status.Display = this.signatoryUpdate;

                this.$emit("signature-updated", this.updatedSignature);
            },
            toggleEditingRecipient(recipientId, isEditing) {
                this.recipientsBeingEdited[recipientId] = isEditing;
                this.inEditMode = this.isInEditMode();
            },
            isInEditMode() {
                return Object.keys(this.recipientsBeingEdited).some((r) => {
                    return this.recipientsBeingEdited[r] == true;
                });
            },
            resendNotifications() {
                this.$emit("resend-notifications");
            }
        }
    };
</script>
